<div class="container-fluid inquiry-container">
  <div
    class="sticky-content-container"
    baseIsSticky
    stickyClass="sticky-top"
    [stickyScrollDistance]="stickyHeaderScrollDistance"
    (stickyChange)="onStickyChange($event)"
  >
    <div class="position-relative">
      <div class="inquiry-calendar position-relative">
        <base-inquiry-calendar></base-inquiry-calendar>
      </div>
      <div class="inquiry-actions-and-filters py-4">
        <base-customer-offers-search-and-legend
          (sortItemClicked)="sortOffersList($event)"
          [activeSortOrderDirection]="listOrderDirection"
          [activeSortOrderKey]="listOrderKey"
          [branches]="branches"
          [filtersForm]="filtersForm"
          [isFiltersVisible]="hasFiltersValues"
          [mainQualifications]="mainQualifications"
          [widgetTemplate]="widgetTemplate"
          class="py-4"
        ></base-customer-offers-search-and-legend>
      </div>
    </div>
  </div>
  <div class="position-relative pb-8">
    <base-customer-inquiry-offers-list
      [offers]="filteredOffers"
      [shiftTimesWithFlex]="shiftTimesWithFlex"
      (scrollListDown)="loadOffersNextPage()"
    ></base-customer-inquiry-offers-list>
  </div>
</div>

<base-inquiry-details-sidebar
  [inquiryId]="copiedInquiry?.id"
  [inquiry]="inquiry"
  [isSidebarVisible]="isSidebarVisible"
  [offersCount]="offersCount"
  [shiftTimes]="shiftTimes"
></base-inquiry-details-sidebar>

<ng-template #widgetTemplate>
  <div
    [ngClass]="inquiry?.status !== baseInquiryStatus.closed ? 'justify-content-end' : 'justify-content-between'"
    class="d-flex align-items-center right-content h-100"
  >
    <base-action-dropdown
      *ngIf="
        inquiry && (canPublishInquiry || (hasCloseInquiryPermission && inquiry.status !== baseInquiryStatus.closed));
        else inquiryStatus
      "
      [color]="inquiry.status === baseInquiryStatus.closed ? 'outline-blue' : 'outline-success'"
      [items]="inquiryActions"
      [label]="'states.' + inquiryStatusValue[inquiry.status]"
      class="mw-100 me-3"
      (listItemClicked)="handleClick($event)"
    ></base-action-dropdown>
    <ng-template #inquiryStatus>
      <p
        *ngIf="inquiry"
        baseTruncate
        class="fw-bold d-inline-block text-success mb-0 me-3"
        [ngClass]="{
          'inquiry-closed-state': inquiry.status === baseInquiryStatus.closed,
          'text-success': inquiry.status === baseInquiryStatus.published
        }"
      >
        {{ 'states.' + inquiryStatusValue[inquiry.status] | translate | uppercase }}
      </p>
    </ng-template>
    <div
      *ngIf="inquiry && inquiry.status === this.baseInquiryStatus.closed"
      class="reason-info"
    >
      <p
        *ngIf="inquiry.closedBy; else closedBySystemMessage"
        [baseDynamicFontSize]="100"
        class="mb-0 me-3 text-center"
      >
        <ng-container *ngIf="inquiry.closedNote; else noClosingReasonSpecified">
          {{ 'operations.reason' | translate }}: {{ inquiry.closedNote }}
        </ng-container>
        <ng-template #noClosingReasonSpecified>
          <span>{{ 'inquiry.closeInquiry.closedWithoutReason' | translate }}</span>
        </ng-template>
      </p>
      <ng-template #closedBySystemMessage>
        <p class="mb-0 me-3 text-center">{{ 'inquiry.closedBySystem' | translate }}</p>
      </ng-template>
    </div>

    <div class="d-flex gap-2">
      <base-button
        *ngIf="!!inquiry?.directlyInquired"
        [ngbTooltip]="directInquiryTooltip"
        color="dark"
        icon="fa-solid fa-user"
        iconClass="pe-1"
        [iconSize]="buttonSizes.md"
      ></base-button>
      <base-button
        (btnClick)="copyInquiryHandler($event)"
        [iconSize]="buttonSizes.md"
        [ngbTooltip]="'inquiry.createByCopy' | translate"
        color="dark"
        icon="fa-solid fa-copy"
        stateClass="pe-1"
      ></base-button>
      <base-button
        *ngIf="!inquiry?.directlyInquired"
        [ngbTooltip]="'inquiry.inquiryRecipientsTooltip' | translate"
        color="dark"
        icon="fa-solid fa-split"
        iconClass="pe-1"
        [iconSize]="buttonSizes.md"
        (btnClick)="openInquiredServiceProvidersModal($event)"
      ></base-button>
    </div>
  </div>
</ng-template>

<ng-template #staffRequest>
  <base-customer-staff-request-modal
    [inquiry]="copiedInquiry"
    [copiedInquiryId]="inquiry?.id"
    [isInquiryDefaultFilter]="true"
    [modalRef]="modalRef"
  ></base-customer-staff-request-modal>
</ng-template>

<ng-template #closeInquiryModal>
  <base-customer-close-inquiry-form [modalRef]="onInquiryCloseModalRef"></base-customer-close-inquiry-form>
</ng-template>

<ng-template #directInquiryTooltip>
  <base-direct-inquiry-tooltip
    *ngIf="inquiry"
    [profileName]="
      inquiry.directlyInquired
        ? inquiry.directlyInquired.profile.firstName + ' ' + inquiry.directlyInquired.profile.lastName
        : ''
    "
    [branchName]="inquiry.directlyInquired?.branch?.name || ''"
  ></base-direct-inquiry-tooltip>
</ng-template>

<ng-template #inquiredServiceProvidersModal>
  <base-customer-inquired-service-providers-modal
    *ngIf="inquiry"
    [isInquiryClosed]="inquiry.status === baseInquiryStatus.closed"
    [inquiryClosingDate]="inquiry.closed"
    [inquiryId]="inquiry.id"
  ></base-customer-inquired-service-providers-modal>
</ng-template>

<ng-template #serviceProviderSelectModal>
  <base-customer-service-provider-select-modal
    [modalRef]="serviceProviderSelectModalRef"
    [inquiryId]="unpublishedInquiryId"
  ></base-customer-service-provider-select-modal>
</ng-template>
